import React, { useEffect, useState } from "react";
import MainBg from "../../components/Mainbg";
import {
  PieChart,
  Pie,
  Tooltip,
  Cell,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
} from "recharts";
import secureLocalStorage from "react-secure-storage";
import BaseImage from "../../assets/images/dasboard/base.webp";
import axios from "axios";
import { GET_TRACK_REPORT } from "../../config/ApisCollection";
import fs0 from "../../assets/images/fastingstreek/fs-0.png";
import fs1 from "../../assets/images/fastingstreek/fs-1.png";
import fs2 from "../../assets/images/fastingstreek/fs-2.png";
import {
  monthlist,
  getCurrentWeek,
  getDatesWithDayNames,
} from "../../function/functions";
import {
  TrackDateFilterSection,
  DaySlideSection,
  DayWeekTabSection,
  WeekSlideSection,
  NotFound,
} from "../../components/TrackCommonSection";

const FastingTrack = ({ weekStart = "Sunday" }) => {
  const accessToken = secureLocalStorage.getItem("accessToken");
  // Update current date, month, and year on component mount
  const now = new Date();
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed and should be 2 digits
  const day = String(now.getDate()).padStart(2, "0"); // Ensure day is 2 digits
  const current_date = `${year}-${month}-${day}`; // Ensure day is 2 digits
  // const dayOfWeek = now.getDay();
  const dayOfWeek = day;

  // const current_month = month;
  const current_dayinweek = 3;
  // Get the current week of the month
  const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
  const firstWeekday = firstDayOfMonth.getDay(); // Day of the week for the 1st of the month
  const currentWeekfind = Math.ceil((now.getDate() + firstWeekday) / 7); // Week number in the month

  // console.log(currentWeekfind);
  const [dataTab, setDataTab] = useState("Daily");
  const [bardata, setBarData] = useState([]);
  const [activeDayTab, setActiveDayTab] = useState(current_date || null);
  const [activeWeekTab, setActiveWeekTab] = useState(currentWeekfind - 1);
  const [currentMonth, setCurrentMonth] = useState(month || null);
  const [currentYear, setCurrentYear] = useState(year || null);
  const [reportData, setReportData] = useState(null);

  let eatingfastingdata;

  if (
    reportData?.finalSetDataWithDate &&
    reportData?.finalSetDataWithDate[activeDayTab]
  ) {
    const eatinglogtimemin =
      reportData?.finalSetDataWithDate[activeDayTab][0].logInMinutes_eating;
    const fastinglogtimemin =
      reportData?.finalSetDataWithDate[activeDayTab][0].logInMinutes_fasting;
    const eating_perc = Math.floor(
      (100 * eatinglogtimemin) / (eatinglogtimemin + fastinglogtimemin)
    );

    eatingfastingdata = [
      {
        name: "Fasting",
        value: 100 - eating_perc,
        timeVal: fastinglogtimemin,
      },
      {
        name: "Eating",
        value: eating_perc,
        timeVal: eatinglogtimemin,
      },
    ];
  } else {
    eatingfastingdata = [
      {
        name: "Fasting",
        value: 0,
        timeVal: 0,
      },
      {
        name: "Eating",
        value: 0,
        timeVal: 0,
      },
    ];
  }

  const handleChange = (event) => {
    setCurrentMonth(event.target.value);
  };
  // Colors for the pie slices
  const eatingfastingdata_COLORS = ["#FFDABF", "#FE770169"];

  const weeklist = ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5"];
  // Function to get the current week with dates and day names

  const GetTrackReport = async () => {
    const getParams = {
      month: currentMonth,
      year: currentYear,
    };

    const getHeaders = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios.post(
        GET_TRACK_REPORT,
        getParams,
        getHeaders
      );

      setReportData(response.data);
      if (response?.data?.finalSetDataWithWeek?.length == activeWeekTab) {
        setActiveWeekTab(activeWeekTab - 1);
      }
      let bar_data_arr = [];
      response.data &&
        response.data?.finalSetDataWithWeek &&
        response.data?.finalSetDataWithWeek[activeWeekTab] &&
        Object.entries(response.data?.finalSetDataWithWeek[activeWeekTab]?.week)
          .length > 0 &&
        Object.entries(
          response.data?.finalSetDataWithWeek[activeWeekTab]?.week
        ).forEach((item, index) => {
          bar_data_arr.push({
            name: item[0]?.slice(0, 3)?.toLocaleUpperCase(),
            Eating: item[1][0]?.logInMinutes_eating || 0,
            Fasting: item[1][0]?.logInMinutes_fasting || 0,
            amt:
              item[1][0]?.logInMinutes_eating ||
              0 + item[1][0]?.logInMinutes_fasting ||
              0,
          });
          // console.log(item);
        });
      setBarData(bar_data_arr);
    } catch (error) {
      // console.log(error);
    }
  };

  // const currentWeek = getCurrentWeek(weekStart);
  const currentWeek = getDatesWithDayNames(year, currentMonth - 1);

  // console.log(dates);

  useEffect(() => {
    GetTrackReport();
    // console.log(activeDayTab);
  }, [activeDayTab, currentMonth, activeWeekTab]);

  return (
    <MainBg>
      <div className="container lg:w-1/4 md:w-1/3 w-full m-auto">
        <TrackDateFilterSection
          currentMonth={currentMonth}
          month={month}
          year={year}
          monthlist={monthlist}
          setCurrentYear={setCurrentYear}
          currentYear={currentYear}
          handleChange={handleChange}
        />

        <DayWeekTabSection dataTab={dataTab} setDataTab={setDataTab} />
      </div>

      {dataTab === "Daily" ? (
        <>
          <DaySlideSection
            activeDayTab={activeDayTab}
            currentWeek={currentWeek}
            dayOfWeek={dayOfWeek}
            setActiveDayTab={setActiveDayTab}
          />

          <div className="flex justify-center">
            <div className="flex flex-col">
              {eatingfastingdata &&
              (eatingfastingdata[0]?.value > 0 ||
                (eatingfastingdata[1] && eatingfastingdata[1]?.value > 0)) ? (
                <>
                  <PieChart width={250} height={250}>
                    <Pie
                      data={eatingfastingdata}
                      cx={125}
                      cy={125}
                      labelLine={false}
                      outerRadius={75}
                      fill="#8884d8"
                      dataKey="value"
                    >
                      {eatingfastingdata.map((entry, index) => (
                        <Cell
                          key={`cell-${index}`}
                          fill={
                            eatingfastingdata_COLORS[
                              index % eatingfastingdata_COLORS.length
                            ]
                          }
                        />
                      ))}
                    </Pie>
                    <Tooltip />
                  </PieChart>
                  <div className="border-t pt-3 border-[#ddd] flex justify-evenly mb-20">
                    {eatingfastingdata.map((entry, index) => (
                      <div className="" key={index}>
                        <p className="mb-0 font-bold italic text-lg">
                          {" "}
                          {(entry.timeVal / 60)?.toFixed(2)}h
                        </p>
                        <p
                          className={`text-[${
                            index === 0 ? "#FFDABF" : "#FE770169"
                          }] text-xs`}
                        >
                          {entry.name}
                        </p>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <>{reportData && <NotFound />}</>
              )}
            </div>
          </div>
        </>
      ) : (
        <>
          <WeekSlideSection
            weeklist={weeklist}
            activeWeekTab={activeWeekTab}
            setActiveWeekTab={setActiveWeekTab}
            currentWeekfind={currentWeekfind}
          />

          <div className="container mx-auto p-4 mt-10">
            {reportData?.finalSetDataWithWeek &&
            reportData?.finalSetDataWithWeek[activeWeekTab] ? (
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {/* Table section  */}
                <div>
                  {reportData &&
                    reportData?.finalSetDataWithWeek &&
                    reportData?.finalSetDataWithWeek[activeWeekTab] &&
                    Object.entries(
                      reportData?.finalSetDataWithWeek[activeWeekTab]?.week
                    ).length > 0 &&
                    Object.entries(
                      reportData?.finalSetDataWithWeek[activeWeekTab]?.week
                    ).map((week_day, index) => {
                      const day_date = week_day[1][0]?.date?.slice(8, 10);
                      let NaN_date = "__";

                      return (
                        <div key={index}>
                          <div className="flex border-b justify-between	items-center">
                            <div className="p-2 text-capitalize">
                              <p>
                                {week_day[0]?.slice(0, 3)},{" "}
                                {day_date || NaN_date}
                              </p>
                            </div>
                            {week_day[1][0]?.logInMinutes_fasting ? (
                              <div className="flex">
                                <div className="p-2">
                                  <p className="font-bold">
                                    {week_day[1][0]?.logInMinutes_fasting}m
                                  </p>
                                  <div className="text-xs flex items-center gap-1">
                                    <div className="h-[8px] w-[8px] bg-[#FE7701] rounded-full"></div>{" "}
                                    Fasting
                                  </div>
                                </div>
                                <div className="p-2">
                                  <p className="font-bold">
                                    {week_day[1][0]?.logInMinutes_eating}m
                                  </p>
                                  <div className="text-xs flex items-center gap-1">
                                    <div className="h-[8px] w-[8px] bg-[#ffdabf5c] rounded-full"></div>{" "}
                                    Eating
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <>No record</>
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>

                {/* Graph section */}
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart
                    width={500}
                    height={300}
                    data={bardata}
                    margin={{
                      top: 20,
                      right: 30,
                      left: 20,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    {/* <YAxis /> */}
                    {/* <Tooltip /> */}
                    <Legend />
                    <Bar dataKey="Fasting" stackId="a" fill="#FF9950" />
                    <Bar dataKey="Eating" stackId="a" fill="#ff994f94" />
                  </BarChart>
                </ResponsiveContainer>
                <div>
                  <div
                    className={`${
                      reportData &&
                      reportData?.finalSetDataWithWeek &&
                      reportData?.finalSetDataWithWeek[activeWeekTab] &&
                      reportData?.finalSetDataWithWeek[activeWeekTab].fastrick
                        ? "fastiweekbox sm:w-3/4 w-full mx-auto mb-10"
                        : "hidden"
                    }`}
                  >
                    <div className="fastiweekboxtit text-sm font-semibold">
                      Your fasting streak
                    </div>
                    <div className="fasweekdes mb-5">
                      {reportData &&
                        reportData?.finalSetDataWithWeek &&
                        reportData?.finalSetDataWithWeek[activeWeekTab] &&
                        Object.entries(
                          reportData?.finalSetDataWithWeek[activeWeekTab]
                            .fastrick
                        ).map((row, index) => (
                          <div className="tabroe" key={index}>
                            <img
                              loading="lazy"
                              src={
                                row[1] == 100
                                  ? fs2
                                  : row[1] > 0 && row[1] < 100
                                  ? fs1
                                  : fs0
                              }
                              alt="fireac"
                              className="w-6"
                            />
                            <div className="fastiweekboxtext text-xs mt-1 font-medium text-capitalize">
                              {row[0]?.slice(0, 3)}
                            </div>
                          </div>
                        ))}
                    </div>
                    <div className="text-xs font-medium text-center">
                      <span className="">You’re </span>
                      <span className="text-[#fe7701]"> 40% more likely</span>
                      <span className=""> to achieve your goal</span>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              reportData && <NotFound />
            )}
          </div>
        </>
      )}
    </MainBg>
  );
};

export default React.memo(FastingTrack);
